export const introduction =
  'SteamWood® består av Europeisk Ask, som efter värme- och ångbehandling erhåller en homogent gyllene mörk nyans med mycket god beständighet mot fukt och röta. Vid utomhusbruk får träet obehandlat efterhand en silvergrå patina. Vid behandling med olja (rekommenderas), behåller träet sin mörka nyans.'

export const advantages = {
  header: 'Fördelar',
  body:
    'SteamWood® (SW) är ett gott alternativ till teak och uppnår motsvarande beständighet mot vatten, fukt och röta som teak. Tester utförda bland annat vid Universitetet i Dresden har påvisat att Steamwood® uppnår samma motståndskraft (Class 1 durability) som teak vad avser fukt och röta. SW är miljövänligt och kan erhållas med FSC-märkning.',
}

export const production = {
  header: 'Tillverkning',
  paragraphs: [
    'SW tillverkas av Europeisk Ask som behandlas under intensiv värme upp till 200°C i fuktig miljö. Ju högre temperatur man behandlar träet med, desto mörkare blir träets nyans, men samtidigt ökar också dess sprödhet. Tillverkningsprosessen tillför inga tillsatser, varken naturliga eller kemiska, utan består endast av värmebehandling under tillförsel av fukt i form av vattenånga.',
    'Behandlingen medför, förutom att träet mörknar och att dess cellers möjlighet att ta upp fukt minskar, även att träets förmåga att motstå röta förbättras. Resultatet får egenskaper som normalt bara återfinns i tropiska trädslag - ett vackert motståndskraftigt trädslag med god formstabilitet.',
  ],
}

export const processing = {
  header: 'Bearbetning och nåtning',
  body:
    'SW är lättbearbetat och har en homogen nyans genom hela träet. Då det är mycket hårt rekommenderas tättandade (hårdmetall)skär. Nåtning av SW genomförs i enlighet med teaknåtning.',
}

export const treatment = {
  header: 'Behandling',
  body:
    'SW rekomenderas en årlig rengöring och behandling med träolja, företrädesvis teakolja, för att behålla sina goda vatten- och rötbeständiga egenskaper. Vidare behåller det sin mörka nyans vid behandling med olja.',
}

export const products = {
  header: 'Produkter',
  body:
    'Erlandson Trade saluför för närvarande SteamWood® som däcksribb 40 x 12mm (1190) samt mittfisk 12 x 95mm (1192), 12 x 120mm (1194) och 12 x 145 (1196)',
}

export const usageAreas = {
  header: 'Användningsområden',
  body:
    'SW uppnår ej en högre fukthalt än 15-16%. Detta är en stor fördel vid extriört och marint bruk. SW nyttjas bl a som material vid utomhusmöbler och utomhusgolv. Båtindustrien har med mycket goda resultat nyttjat SW som båtdäcks- och båtinredningsmaterial.',
  examples: [
    {
      title: 'Maritime Møbler AS:',
      src: 'Maritime.jpg',
    },
    {
      title: 'Askeladden (däcksmaterial, badplattform)',
      src: 'Askeladden2.jpg',
    },
    {
      title: 'Windy boats, däcksmaterial',
      src: 'Windy1.jpg',
    },
    {
      title: 'Windy boats, interiör',
      src: 'Windy2.jpg',
    },
    {
      title: 'Vestadmyr (landgångar)',
      src: 'Vestadmyr1.jpg',
    },
    {
      title: 'Princess Yachts och Sunseeker Yachts (däcksmaterial)',
      src: 'Princess1.jpg',
    },
    {
      title: 'Princess Yachts och Sunseeker Yachts (interiör)',
      src: 'Princess2.jpg',
    },
  ],
}
